import { Box, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function Cart() {
  const location = useLocation().pathname;
  const theme = useTheme();

  return (
    <Stack>
      <Stack
        direction={"row-reverse"}
        gap={{ xs: ".5rem", sm: "1rem" }}
        sx={{ maxWidth: "1040px", width: "100%", mx: "auto", my: "2rem" , px:"3rem" }}
      >
        
      </Stack>
      {/* Flashes */}
      <Outlet />
    </Stack>
  );
}
